module.exports = "/_next/static/images/cm-a25245fb01b3de4a3fbb9bb54a7406aa.png";